import React from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import WhyJSkoolSection from './components/WhyJSkoolSection';
import ProgramsSection from './components/ProgramsSection';
import ModernLearningSection from './components/ModernLearningSection';
import TeamSection from './components/TeamSection';
import InspirationSection from './components/InspirationSection';
import EventsSection from './components/EventsSection';
import JoinUsSection from './components/ContactSection';
import Footer from './components/Footer';
import MokshaPatamPage from './components/MokshaPatamPage';
import GamesPage from './components/GamesPage';
import JskoolGptPage from './components/JskoolGptPage';


const App: React.FC = () => {
  const [pathname, setPathname] = React.useState(window.location.pathname);

  const renderPage = () => {
    switch (pathname) {
      case '/mokshapatam':
        return <MokshaPatamPage />;
      case '/games':
        return <GamesPage />;
      case '/jskool-gpt':
        return <JskoolGptPage />;
      default:
        return (
          <>
            <HeroSection />
            <AboutSection />
            <WhyJSkoolSection />
            <ProgramsSection />
            <ModernLearningSection />
            <TeamSection />
            <InspirationSection />
            <EventsSection />
            <JoinUsSection />
          </>
        );
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow flex flex-col">
        {renderPage()}
      </main>
      <Footer />
    </div>
  );
};

export default App;